"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ReviewDeckCreateWrapper = function ReviewDeckCreateWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "selected", _descriptor, _this);
      _initializerDefineProperty(_this, "duplicateNameError", _descriptor2, _this);
      _initializerDefineProperty(_this, "askForDeleteConfirmation", _descriptor3, _this);
      _initializerDefineProperty(_this, "askForDeleteCardsConfirmation", _descriptor4, _this);
      _initializerDefineProperty(_this, "askForResetConfirmation", _descriptor5, _this);
      _initializerDefineProperty(_this, "message", _descriptor6, _this);
      _initializerDefineProperty(_this, "deletingDeck", _descriptor7, _this);
      _initializerDefineProperty(_this, "deletingCards", _descriptor8, _this);
      _initializerDefineProperty(_this, "resettingReviews", _descriptor9, _this);
      _initializerDefineProperty(_this, "afterCreateDeck", _descriptor10, _this);
      _initializerDefineProperty(_this, "dailyGoalMin", _descriptor11, _this);
      _initializerDefineProperty(_this, "dailyGoalMax", _descriptor12, _this);
      _initializerDefineProperty(_this, "dailyGoalIsTooLow", _descriptor13, _this);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "name",
      get: function get() {
        var _this$props$deck;
        return this.selected['name'] === null ? (_this$props$deck = this.props.deck) === null || _this$props$deck === void 0 ? void 0 : _this$props$deck.name : this.selected['name'];
      }
    }, {
      key: "archived",
      get: function get() {
        var _this$props$deck2;
        return this.selected['archived'] === null ? (_this$props$deck2 = this.props.deck) === null || _this$props$deck2 === void 0 ? void 0 : _this$props$deck2.archived : this.selected['archived'];
      }
    }, {
      key: "dailyGoal",
      get: function get() {
        return this.selected['dailyGoal'];
      }
    }, {
      key: "defaultReviewDeck",
      get: function get() {
        var _this$props$deck3;
        return this.selected['defaultReviewDeck'] === null ? (_this$props$deck3 = this.props.deck) === null || _this$props$deck3 === void 0 ? void 0 : _this$props$deck3.defaultReviewDeck : this.selected['defaultReviewDeck'];
      }
    }, {
      key: "useDailyGoal",
      get: function get() {
        var _this$props$deck4;
        return this.selected['useDailyGoal'] === null ? (_this$props$deck4 = this.props.deck) === null || _this$props$deck4 === void 0 ? void 0 : _this$props$deck4.useDailyGoal : this.selected['useDailyGoal'];
      }
    }, {
      key: "color",
      get: function get() {
        var _this$props$deck5;
        return this.selected['color'] === null ? ((_this$props$deck5 = this.props.deck) === null || _this$props$deck5 === void 0 ? void 0 : _this$props$deck5.color) || 'blue' : this.selected['color'];
      }
    }, {
      key: "languageId",
      get: function get() {
        var _this$props$deck6;
        return this.selected['languageId'] === null ? ((_this$props$deck6 = this.props.deck) === null || _this$props$deck6 === void 0 ? void 0 : _this$props$deck6.languageId) || _state.AppUI.targetLanguageId : this.selected['languageId'];
      }
    }, {
      key: "enabledSubmitButton",
      get: function get() {
        return !this.duplicateNameError && this.dailyGoalIsValid && (0, _utils.isPresent)(this.name) && (this.dirtyField('name') || this.dirtyField('color') || this.dirtyField('defaultReviewDeck') || this.dirtyField('useDailyGoal') || this.dirtyField('dailyGoal') || this.dirtyField('languageId') || this.dirtyField('archived'));
      }
    }, {
      key: "onSetName",
      value: function onSetName(name) {
        var _this2 = this;
        this.selected['name'] = name;
        this.duplicateNameError = (0, _utils.isPresent)(_state.AppUI.reviewDeckStore.indexData.find(function (item) {
          var _item$name;
          return ((0, _utils.isBlank)(_this2.props.deck) || item.id !== _this2.props.deck.id) && (item === null || item === void 0 || (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toLowerCase()) === (name === null || name === void 0 ? void 0 : name.toLowerCase());
        }));
      }
    }, {
      key: "onSetDailyGoal",
      value: function onSetDailyGoal(dailyGoal) {
        this.selected['dailyGoal'] = dailyGoal;
        setTimeout(this.setDailyGoalIsTooLow, 800);
      }
    }, {
      key: "setDailyGoalIsTooLow",
      value: function setDailyGoalIsTooLow() {
        this.dailyGoalIsTooLow = this.dailyGoal < this.dailyGoalMin && this.dirtyField('dailyGoal') && !(0, _utils.isBlank)(this.dailyGoal);
      }
    }, {
      key: "dailyGoalIsTooHigh",
      get: function get() {
        return this.dailyGoal > this.dailyGoalMax && this.dirtyField('dailyGoal');
      }
    }, {
      key: "dailyGoalIsValid",
      get: function get() {
        return !this.dailyGoalIsTooLow && !this.dailyGoalIsTooHigh;
      }
    }, {
      key: "onSetColor",
      value: function onSetColor(color) {
        this.selected['color'] = color;
      }
    }, {
      key: "dirtyField",
      value: function dirtyField(field) {
        return (0, _utils.isPresent)(this.selected[field]) && (!this.props.deck || this.selected[field] !== this.props.deck[field]);
      }
    }, {
      key: "onSetAskForDeleteConfirmation",
      value: function onSetAskForDeleteConfirmation(askForDeleteConfirmation) {
        this.askForDeleteConfirmation = askForDeleteConfirmation;
      }
    }, {
      key: "onSetAskForResetConfirmation",
      value: function onSetAskForResetConfirmation(askForResetConfirmation) {
        this.askForResetConfirmation = askForResetConfirmation;
      }
    }, {
      key: "onSetAskForDeleteCardsConfirmation",
      value: function onSetAskForDeleteCardsConfirmation(askForDeleteCardsConfirmation) {
        this.askForDeleteCardsConfirmation = askForDeleteCardsConfirmation;
      }
    }, {
      key: "onToggleDefaultReviewDeck",
      value: function onToggleDefaultReviewDeck() {
        this.selected['defaultReviewDeck'] = !this.defaultReviewDeck;
      }
    }, {
      key: "onToggleUseDailyGoal",
      value: function onToggleUseDailyGoal() {
        this.selected['useDailyGoal'] = !this.useDailyGoal;
      }
    }, {
      key: "onToggleArchived",
      value: function onToggleArchived() {
        var _this$props$deck7;
        if ((_this$props$deck7 = this.props.deck) !== null && _this$props$deck7 !== void 0 && _this$props$deck7.defaultReviewDeck) {
          this.message = 'Default decks cannot be archived.';
        } else {
          this.selected['archived'] = !this.archived;
        }
      }
    }, {
      key: "onChangeLanguage",
      value: function onChangeLanguage(value) {
        this.selected['languageId'] = value;
      }
    }, {
      key: "updateReviewAfter",
      value: function updateReviewAfter(numberDays) {
        _state.AppUI.deckStore.updateReviewAfter({
          ids: {
            deckId: this.props.deck.id
          },
          data: {
            number_days: numberDays
          }
        }, this.afterUpdateReviewAfter.bind(this, numberDays));
      }
    }, {
      key: "afterUpdateReviewAfter",
      value: function afterUpdateReviewAfter(numberDays, resp) {
        var _this3 = this;
        if (resp.success) {
          var days = numberDays === 1 ? '1 day' : "".concat(numberDays, " days");
          this.message = "Your reviews have been pushed forward ".concat(days, ".");
          setTimeout(function () {
            return _this3.message = null;
          }, 3000);
          _state.AppUI.reviewDeckStore.getIndex({});
        }
      }
    }, {
      key: "onSubmit",
      value: function onSubmit() {
        if (!this.enabledSubmitButton) {
          return;
        }
        var data = {
          userId: _state.AppUI.user.id,
          deckType: 'review',
          name: this.name,
          color: this.color,
          defaultReviewDeck: this.defaultReviewDeck,
          useDailyGoal: this.useDailyGoal,
          languageId: this.languageId,
          archived: this.archived,
          dailyGoal: this.dailyGoal
        };
        if (this.props.deck) {
          this.props.deck.set('name', this.name);
          this.props.deck.set('color', this.color);
          this.props.deck.set('defaultReviewDeck', this.defaultReviewDeck);
          this.props.deck.set('useDailyGoal', this.useDailyGoal);
          this.props.deck.set('archived', this.archived);
          this.props.deck.set('dailyGoal', this.dailyGoal);
          _state.AppUI.deckStore.update({
            ids: {
              deckId: this.props.deck.id
            },
            data: data
          }, this.afterUpdate);
        } else {
          _state.AppUI.deckStore.create({
            data: data
          }, this.afterCreate);
        }
      }
    }, {
      key: "onDeleteDeck",
      value: function onDeleteDeck() {
        if (!this.deletingDeck) {
          this.deletingDeck = true;
          _state.AppUI.deckStore.destroy({
            ids: {
              deckId: this.props.deck.id
            }
          }, this.props.closeOptionsAndUpdate);
        }
      }
    }, {
      key: "onDeleteCards",
      value: function onDeleteCards() {
        if (!this.deletingCards) {
          this.deletingCards = true;
          _state.AppUI.deckStore.deleteReviewCards({
            ids: {
              deckId: this.props.deck.id
            }
          }, this.props.closeOptionsAndUpdate);
        }
      }
    }, {
      key: "onResetCards",
      value: function onResetCards() {
        this.resettingReviews = true;
        _state.AppUI.deckStore.resetReviewCards({
          ids: {
            deckId: this.props.deck.id
          }
        }, this.props.closeOptionsAndUpdate);
      }
    }, {
      key: "afterUpdate",
      value: function afterUpdate() {
        this.message = 'This deck has been updated.';
        this.resetForm();
        this.loadDecks();
      }
    }, {
      key: "afterCreate",
      value: function afterCreate() {
        this.message = 'This deck has been created. ';
        this.resetForm();
        this.loadDecks();
        this.afterCreateDeck = true;
      }
    }, {
      key: "resetForm",
      value: function resetForm() {
        this.selected = {
          name: null,
          color: null,
          defaultReviewDeck: null,
          useDailyGoal: null,
          languageId: this.languageId
        };
        if ((0, _utils.isPresent)(this.props.deck)) {
          this.selected['dailyGoal'] = this.props.deck.dailyGoal;
        }
      }
    }, {
      key: "loadDecks",
      value: function loadDecks() {
        _state.AppUI.reviewDeckStore.getIndex();
      }
    }, {
      key: "showDailyGoalSetting",
      get: function get() {
        return (0, _utils.isPresent)(this.props.deck) && this.dailyGoalMax > 50;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          onSubmit: this.onSubmit,
          name: this.name,
          archived: this.archived,
          dailyGoal: this.dailyGoal,
          color: this.color,
          languageId: this.languageId,
          message: this.message,
          onSetName: this.onSetName,
          onSetColor: this.onSetColor,
          onSetDailyGoal: this.onSetDailyGoal,
          enabledSubmitButton: this.enabledSubmitButton,
          onDeleteDeck: this.onDeleteDeck,
          onDeleteCards: this.onDeleteCards,
          duplicateNameError: this.duplicateNameError,
          askForDeleteConfirmation: this.askForDeleteConfirmation,
          onSetAskForDeleteConfirmation: this.onSetAskForDeleteConfirmation,
          askForResetConfirmation: this.askForResetConfirmation,
          onSetAskForResetConfirmation: this.onSetAskForResetConfirmation,
          askForDeleteCardsConfirmation: this.askForDeleteCardsConfirmation,
          onSetAskForDeleteCardsConfirmation: this.onSetAskForDeleteCardsConfirmation,
          showDeckUpdatedMessage: this.showDeckUpdatedMessage,
          defaultReviewDeck: this.defaultReviewDeck,
          useDailyGoal: this.useDailyGoal,
          onToggleDefaultReviewDeck: this.onToggleDefaultReviewDeck,
          onToggleUseDailyGoal: this.onToggleUseDailyGoal,
          onToggleArchived: this.onToggleArchived,
          onChangeLanguage: this.onChangeLanguage,
          updateReviewAfter: this.updateReviewAfter,
          afterCreateDeck: this.afterCreateDeck,
          dailyGoalMin: this.dailyGoalMin,
          dailyGoalMax: this.dailyGoalMax,
          dailyGoalIsTooLow: this.dailyGoalIsTooLow,
          dailyGoalIsTooHigh: this.dailyGoalIsTooHigh,
          showDailyGoalSetting: this.showDailyGoalSetting,
          onResetCards: this.onResetCards,
          resettingReviews: this.resettingReviews
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "selected", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return {
        name: null,
        color: this.props.deck ? null : 'blue',
        defaultReviewDeck: null,
        useDailyGoal: null,
        languageId: null,
        archived: this.props.deck ? this.props.deck.archived : false,
        dailyGoal: this.props.deck ? this.props.deck.dailyGoal : null
      };
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "duplicateNameError", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "askForDeleteConfirmation", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "askForDeleteCardsConfirmation", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "askForResetConfirmation", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "message", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "deletingDeck", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "deletingCards", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "resettingReviews", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "afterCreateDeck", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "dailyGoalMin", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 12;
    }
  }), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "dailyGoalMax", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      var _this$props$deck8, _this$props$deck9;
      return ((_this$props$deck8 = this.props.deck) === null || _this$props$deck8 === void 0 ? void 0 : _this$props$deck8.reviewCardsCount) - ((_this$props$deck9 = this.props.deck) === null || _this$props$deck9 === void 0 ? void 0 : _this$props$deck9.retiredCount);
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "dailyGoalIsTooLow", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "name", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "name"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "archived", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "archived"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "dailyGoal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "dailyGoal"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "defaultReviewDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "defaultReviewDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "useDailyGoal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "useDailyGoal"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "color", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "color"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "languageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "languageId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "enabledSubmitButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "enabledSubmitButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetName", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetName"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetDailyGoal", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetDailyGoal"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setDailyGoalIsTooLow", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setDailyGoalIsTooLow"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "dailyGoalIsTooHigh", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "dailyGoalIsTooHigh"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "dailyGoalIsValid", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "dailyGoalIsValid"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetColor", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetColor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "dirtyField", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "dirtyField"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetAskForDeleteConfirmation", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetAskForDeleteConfirmation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetAskForResetConfirmation", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetAskForResetConfirmation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSetAskForDeleteCardsConfirmation", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSetAskForDeleteCardsConfirmation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleDefaultReviewDeck", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleDefaultReviewDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleUseDailyGoal", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleUseDailyGoal"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onToggleArchived", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onToggleArchived"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onChangeLanguage", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onChangeLanguage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateReviewAfter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "updateReviewAfter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterUpdateReviewAfter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterUpdateReviewAfter"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSubmit", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSubmit"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onDeleteDeck", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onDeleteDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onDeleteCards", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onDeleteCards"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onResetCards", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onResetCards"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterUpdate", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterUpdate"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterCreate", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterCreate"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "resetForm", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "resetForm"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "loadDecks", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "loadDecks"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showDailyGoalSetting", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showDailyGoalSetting"), _class2.prototype), _class2)) || _class;
};
ReviewDeckCreateWrapper.displayName = 'ReviewDeckCreateWrapper';
var _default = exports["default"] = ReviewDeckCreateWrapper;